<template>
  <div>
    <div style="width:1280px">
      <img :src="adminIntro1" usemap="#map" name="adminIntro1" />
      <div align="center">
        <object
          type="text/html"
          width="950"
          height="600"
          data="//player.vimeo.com/video/422716930?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
          allowfullscreen
        ></object>
      </div>
      <img :src="adminIntro2" usemap="#map2" name="adminIntro2" />
      <div align="center">
        <object
          type="text/html"
          width="950"
          height="600"
          data="//player.vimeo.com/video/420987404?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
          allowfullscreen
        ></object>
      </div>
      <img :src="adminIntro3" usemap="#map3" name="adminIntro3" />

      <map name="map">
        <area
          shape="rect"
          coords="418, 2335, 879, 2405"
          v-bind:href="`/shoplus_authservice/${$store.state.mallId}/warrantyPeriod`"
          target="_blank"
        />
        <area
          shape="rect"
          coords="417, 3200, 876, 3276"
          v-bind:href="`/shoplus_authservice/${$store.state.mallId}/createAuthcode`"
          target="_blank"
        />
        <area
          shape="rect"
          coords="418, 4450, 874, 4508"
          style="cursor: pointer;"
          @click.prevent="
            checkVersionAlret(`/shoplus_authservice/${$store.state.mallId}/printqr`)
          "
          target="_blank"
        />
        <area
          shape="rect"
          coords="414, 4706, 883, 4779"
          v-bind:href="`/shoplus_authservice/${$store.state.mallId}/manageAuthcode`"
          target="_blank"
        />
      </map>

      <map name="map2">
        <area
          shape="rect"
          coords="403, 613, 891, 703"
          v-bind:href="`/shoplus_authservice/${$store.state.mallId}/setting`"
          target="_blank"
        />
      </map>
      <map name="map3">
        <area
          shape="rect"
          coords="450, 1164, 845, 1249"
          v-bind:href="`/shoplus_authservice/${$store.state.mallId}/payment`"
          target="_blank"
        />
      </map>
    </div>
  </div>
</template>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data: () => ({
    adminIntro1: require("../../../assets/authservice/images/adminServiceInfo1.png"),
    adminIntro2: require("../../../assets/authservice/images/adminServiceInfo2.png"),
    adminIntro3: require("../../../assets/authservice/images/adminServiceInfo3.png")
  }),
  mixins: [CommonMixin],
  created: function() {},
  methods: {
    moveIntro: function() {
      let route = this.$router.resolve({
        path: `/shoplus_authservice/${this.$store.state.mallId}/serviceIntro`
      });
      window.open(route.href, "_blank");
    },
    checkVersionAlret: function(url) {
      window.open(url, "_blank");
    }
  },
  mounted: function() {}
};
</script>
